// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
interface FuelTypeLimitationReasonOrder {
  DERIVED_FROM_VEHICLE_REGISTER_DATA: number;
  VEHICLE_NOT_FOUND_IN_VEHICLE_REGISTER: number;
  INVALID_VEHICLE_STATUS_IN_VEHICLE_REGISTER: number;
  MISSING_OR_INVALID_VEHICLE_FUEL_TYPE_IN_VEHICLE_REGISTER: number;
  MISSING_OR_INVALID_VEHICLE_EMISSIONS_IN_VEHICLE_REGISTER: number;
}

const FuelTypeLimitationReasonOrder: FuelTypeLimitationReasonOrder = {
  DERIVED_FROM_VEHICLE_REGISTER_DATA: 1,
  VEHICLE_NOT_FOUND_IN_VEHICLE_REGISTER: 2,
  INVALID_VEHICLE_STATUS_IN_VEHICLE_REGISTER: 3,
  MISSING_OR_INVALID_VEHICLE_FUEL_TYPE_IN_VEHICLE_REGISTER: 4,
  MISSING_OR_INVALID_VEHICLE_EMISSIONS_IN_VEHICLE_REGISTER: 5,
};

export default FuelTypeLimitationReasonOrder;
